<template>
  <div v-loading="loading" class="rj-page-card">
    <div v-if="!disStatus" class="rj-page-card__title">
      待确认批次发货明细
    </div>
    <div v-if="disStatus" class="rj-page-card__title">
      已确认批次发货明细
    </div>
    <div class="rj-page-card__content">
      <div class="rj-row">
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              批次发货编号：
            </div>
            <div class="rj-baseinfo__item">
              {{ intelPartialInvoiceInfo.omsBatchNum }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              申请时间：
            </div>
            <div class="rj-baseinfo__item">
              {{ intelPartialInvoiceInfo.createTime }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              申请人：
            </div>
            <div class="rj-baseinfo__item">
              {{ intelPartialInvoiceInfo.applicationName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              下单主体：
            </div>
            <div class="rj-baseinfo__item">
              {{ intelPartialInvoiceInfo.supplyUnitName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              客户名称：
            </div>
            <div class="rj-baseinfo__item">
              {{ intelPartialInvoiceInfo.agentName }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              国家：
            </div>
            <div class="rj-baseinfo__item">
              {{ intelPartialInvoiceInfo.overSeasSalesCountry }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              贸易术语：
            </div>
            <div class="rj-baseinfo__item">
              {{ partialInvoiceDetail.tradeTerms }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              批次发货总金额：
            </div>
            <div class="rj-baseinfo__item">
              {{ intelPartialInvoiceInfo.batchTotalAmount ? Number(intelPartialInvoiceInfo.batchTotalAmount).toFixed(2) : '0.00' }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              付款方式：
            </div>
            <div class="rj-baseinfo__item">
              {{ intelPartialInvoiceInfo.salesTypeName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              外销：
            </div>
            <div class="rj-baseinfo__item">
              {{ intelPartialInvoiceInfo.salesManName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              部门：
            </div>
            <div class="rj-baseinfo__item">
              {{ partialInvoiceDetail.department }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              币种：
            </div>
            <div class="rj-baseinfo__item">
              {{ partialInvoiceDetail.currencyName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              最新更新时间：
            </div>
            <div class="rj-baseinfo__item">
              {{ intelPartialInvoiceInfo.updateTime }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="header" style="margin-top: 46px;">
      <span style="font-weight: 800;">有实物产品</span>
      <el-button type="primary" style="margin-left: 10px;" @click="exportProduct">导出明细</el-button>
    </div>
    <el-table
      v-loading="loading"
      :data="physicalProductPageData"
      border
      style="width: 100%;margin-top: 16px;"
      show-summary
      :summary-method="renderPhysicalSummary"
    >
      <el-table-column type="index" label="序号" width="50px" align="left" fixed="left" />
      <el-table-column prop="contractNum" label="合同编号" />
      <el-table-column prop="itemIndex" label="orderline_id" />
      <el-table-column prop="materialNumber" label="物品代码" />
      <el-table-column prop="productName" label="物品名称" />
      <el-table-column prop="productNum" label="未发货数量" />
      <el-table-column prop="productPriceSigle" label="实际结算单价">
        <template v-slot="{ row }">
          {{ row.productPriceSigle ? Number(row.productPriceSigle).toFixed(2) : '0.00' }}
        </template>
      </el-table-column>
      <el-table-column prop="amountSum" label="实际结算金额">
        <template v-slot="{ row }">
          {{ row.amountSum ? Number(row.amountSum).toFixed(2) : '0.00' }}
        </template>
      </el-table-column>
      <el-table-column prop="expectedDeliveryDate" label="客户期望发货日期">
        <template v-slot="{ row }">
          {{ formatDateOnly(row.expectedDeliveryDate) }}
        </template>
      </el-table-column>
      <el-table-column prop="agreedDate" label="约定交付日期">
        <template v-slot="{ row }">
          {{ formatDateOnly(row.agreedDate) }}
        </template>
      </el-table-column>
      <el-table-column prop="deliveryDateAfterRectification" label="整改后交期">
        <template v-slot="{ row }">
          {{ formatDateOnly(row.deliveryDateAfterRectification) }}
        </template>
      </el-table-column>
      <el-table-column prop="physicalFlag" label="是否实物">
        <template slot-scope="scope">
          <span v-if="resolvePhysicalFlag(scope.row.physicalFlag)">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column prop="batteryFlag" label="是否带电池">
        <template slot-scope="scope">
          <span v-if="scope.row.batteryFlag === true">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column prop="volume" label="预估体积(m³)" />
      <el-table-column prop="warehouse" label="仓位" />
      <el-table-column prop="grossWeight" label="预估重量(kg)" />
      <el-table-column prop="rebateAmount" label="使用返利金额" />
      <el-table-column prop="cashPointRatio" label="现金点比例">
        <template slot-scope="{ row }">
          {{ formatPercentage(row.cashPointRatio) }}
        </template>
      </el-table-column>
      <el-table-column prop="hopeOrderTime" label="希望开单时间" />
    </el-table>
    <div
      v-if="physicalProductList.length > productPagination.physical.pageSize"
      style="text-align: right;margin-top: 10px"
    >
      <el-pagination
        :page-sizes="[50, 100]"
        :page-size="productPagination.physical.pageSize"
        :current-page="productPagination.physical.currentPage"
        layout="total, prev, pager, next, sizes"
        :total="physicalProductList.length"
        @size-change="handlePhysicalSizeChange"
        @current-change="handlePhysicalPageChange"
      />
    </div>
    <div v-if="isDelete !== '1'">
      <div class="header" style="margin-top: 16px;">
        <span style="font-weight: 800;">分配金额</span>
      </div>
      <el-table v-loading="loading" :data="allocatedDetail" border style="width: 80%;margin-top: 16px;">
        <el-table-column type="index" label="序号" width="50px" align="left" fixed="left" />
        <el-table-column prop="contractNum" label="合同号" />
        <el-table-column prop="actualSettlementAmount" label="实际结算金额">
          <template v-slot="{row}">
            {{ row.actualSettlementAmount ? Number(row.actualSettlementAmount).toFixed(2) : '0.00' }}
          </template>
        </el-table-column>
        <el-table-column prop="assignAll" label="已分配金额" />
        <el-table-column prop="advancePaymentAmount" label="预付款金额" />
        <el-table-column prop="prepaymentRatioNum" label="预付款比例" />
        <el-table-column prop="shippedAmount" label="已发货金额" />
        <el-table-column prop="processAmount" label="流程中单据金额" />
        <el-table-column prop="nowShipmentAmount" label="本次发货金额" />
        <el-table-column prop="amountDifference" label="验证金额差异">
          <template v-slot="{row}">
            <span :style="Number(row.amountDifference)<0 && {color:'red'}">{{ Number(row.amountDifference).toFixed(2) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <span>说明:验证金额差异公式=(已分配金额-预付款金额) - (已发货金额+流程中单据金额+本次发货金额) * (1-预付款比例)</span>
      </div>
    </div>
    <div class="header" style="margin-top: 16px;">
      <span style="font-weight: 800;">无实物产品</span>
    </div>
    <el-table
      v-loading="loading"
      :data="nonPhysicalProductPageData"
      border
      class="tableList"
      show-summary
      :summary-method="renderNonPhysicalSummary"
    >
      <el-table-column type="index" label="序号" width="50px" align="left" fixed="left" />
      <el-table-column prop="contractNum" label="合同编号" />
      <el-table-column prop="itemIndex" label="orderline_id" />
      <el-table-column prop="materialNumber" label="物品代码" />
      <el-table-column prop="productName" label="物品名称" />
      <el-table-column prop="productNum" label="未发货数量" />
      <el-table-column prop="productPriceSigle" label="实际结算单价">
        <template v-slot="{ row }">
          {{ row.productPriceSigle ? Number(row.productPriceSigle).toFixed(2) : '0.00' }}
        </template>
      </el-table-column>
      <el-table-column prop="amountSum" label="实际结算金额">
        <template v-slot="{ row }">
          {{ row.amountSum ? Number(row.amountSum).toFixed(2) : '0.00' }}
        </template>
      </el-table-column>
      <el-table-column prop="expectedDeliveryDate" label="客户期望发货日期">
        <template v-slot="{ row }">
          {{ formatDateOnly(row.expectedDeliveryDate) }}
        </template>
      </el-table-column>
      <el-table-column prop="agreedDate" label="约定交付日期">
        <template v-slot="{ row }">
          {{ formatDateOnly(row.agreedDate) }}
        </template>
      </el-table-column>
      <el-table-column prop="deliveryDateAfterRectification" label="整改后交期">
        <template v-slot="{ row }">
          {{ formatDateOnly(row.deliveryDateAfterRectification) }}
        </template>
      </el-table-column>
      <el-table-column prop="physicalFlag" label="是否实物">
        <template slot-scope="scope">
          <span v-if="resolvePhysicalFlag(scope.row.physicalFlag)">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column prop="batteryFlag" label="是否带电池">
        <template slot-scope="scope">
          <span v-if="scope.row.batteryFlag === true">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column prop="volume" label="预估体积(m³)" />
      <el-table-column prop="warehouse" label="仓位" />
      <el-table-column prop="grossWeight" label="预估重量(kg)" />
      <el-table-column prop="rebateAmount" label="原单整单使用返利金额" />
      <el-table-column prop="cashPointRatio" label="原单现金点比例">
        <template slot-scope="{ row }">
          {{ formatPercentage(row.cashPointRatio) }}
        </template>
      </el-table-column>
      <el-table-column prop="hopeOrderTime" label="希望开单时间" />
    </el-table>
    <div
      v-if="nonPhysicalProductList.length > productPagination.nonPhysical.pageSize"
      style="text-align: right;margin-top: 10px"
    >
      <el-pagination
        :page-sizes="[50, 100]"
        :page-size="productPagination.nonPhysical.pageSize"
        :current-page="productPagination.nonPhysical.currentPage"
        layout="total, prev, pager, next, sizes"
        :total="nonPhysicalProductList.length"
        @size-change="handleNonPhysicalSizeChange"
        @current-change="handleNonPhysicalPageChange"
      />
    </div>
    <div v-if="!disStatus">
      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              <span class="required-marker">*</span>地址信息
            </div>
            <div class="rj-baseinfo__item">
              <el-select v-model="partialInvoiceDetail.receiptAddressId" style="width:500px" placeholder="请选择收货地址" clearable>
                <el-option v-for="item in AddressList" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue" />
              </el-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="disStatus" class="rj-row" style="margin-top: 16px;">
      <div class="rj-col-1">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            地址信息 :
          </div>
          <div class="rj-baseinfo__item">
            {{ selectedReceiptAddressLabel || partialInvoiceDetail.receiptAddressId }}
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 22px;">
      <span style="font-weight: 800;">货代信息</span>
    </div>
    <div class="rj-page-card__content">
      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              货代信息:
            </div>
            <div class="rj-baseinfo__item">
              {{ partialInvoiceDetail.freightInfo }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              公司名称:
            </div>
            <div class="rj-baseinfo__item">
              {{ partialInvoiceDetail.corporateName }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              联系人:
            </div>
            <div class="rj-baseinfo__item">
              {{ partialInvoiceDetail.contactName }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              电话：
            </div>
            <div class="rj-baseinfo__item">
              {{ partialInvoiceDetail.phoneNumber }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              邮箱:
            </div>
            <div class="rj-baseinfo__item">
              {{ partialInvoiceDetail.customerEmail }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              地址:
            </div>
            <div class="rj-baseinfo__item">
              {{ partialInvoiceDetail.corporateAddress }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-1">
          <el-divider />
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              是否需要唛头 :
            </div>
            <div class="rj-baseinfo__item">
              <span v-if="partialInvoiceDetail.markType === true">是</span>
              <span v-if="partialInvoiceDetail.markType === false">否</span>
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              <span class="required-marker">*</span>授权邮箱 :
            </div>
            <div class="rj-baseinfo__item">
              <template v-if="!disStatus">
                <div class="email-editor">
                  <el-button
                    v-show="emailStatu"
                    type="primary"
                    style="width:100px"
                    @click="handleAddEmailClick"
                  >
                    添加邮箱
                  </el-button>
                  <el-input
                    v-show="!emailStatu"
                    ref="emailInput"
                    v-model="currentEamil"
                    class="emailInput"
                    placeholder="请输入邮箱"
                    @blur="emailBlur"
                    @keyup.enter.native="emailBlur"
                    @input="validateEmail"
                  />
                  <span v-show="!isEmailValid&&!emailStatu" class="error-message">请输入有效的邮箱地址</span>
                  <div v-if="currentEmailList.length" class="email-tags">
                    <el-tag
                      v-for="item in currentEmailList"
                      :key="item"
                      class="itemTag"
                      size="small"
                      closable
                      @close="handleEmailClose(item)"
                    >
                      {{ item }}
                    </el-tag>
                  </div>
                </div>
              </template>
              <template v-else>
                <el-tag
                  v-for="item in readonlyAuthorizationEmails"
                  :key="item"
                  class="itemTag"
                  size="small"
                >
                  {{ item }}
                </el-tag>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              是否有其他发货单申请合并发货:
            </div>
            <div class="rj-baseinfo__item">
              <el-radio-group
                v-if="!disStatus"
                v-model="partialInvoiceDetail.mergeShip"
              >
                <el-radio :label="true" size="large">是</el-radio>
                <el-radio :label="false" size="large">否</el-radio>
              </el-radio-group>
              <div v-else>
                <span v-if="partialInvoiceDetail.mergeShip === true">是</span>
                <span v-if="partialInvoiceDetail.mergeShip === false">否</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 22px;">
        <span style="font-weight: 800;">发运信息</span>
      </div>
      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              贸易术语:
            </div>
            <div class="rj-baseinfo__item">
              {{ partialInvoiceDetail.tradeTerms }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              包装需求:
            </div>
            <div class="rj-baseinfo__item">
              {{ partialInvoiceDetail.packagingRequirements }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              货运方式:
            </div>
            <div class="rj-baseinfo__item">
              {{ partialInvoiceDetail.modeOfShipping }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              批次:
            </div>
            <div v-if="!disStatus" class="rj-baseinfo__item">
              <el-select v-model="partialInvoiceDetail.batchNum" placeholder="请选择批次" clearable>
                <el-option
                  v-for="item in batchOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div v-else class="rj-baseinfo__item">
              {{ partialInvoiceDetail.batchNum }}
            </div>
          </div>
        </div>
      </div>
      <div class="attachment" style="margin-top: 22px;">
        <div class="header" style="display:flex; align-items:center; gap:10px;">
          <span style="font-weight: 800;">附件信息</span>
          <el-upload
            v-if="!disStatus"
            action=""
            :show-file-list="false"
            :http-request="handleAttachmentUpload"
          >
            <el-button type="primary">上传附件</el-button>
          </el-upload>
        </div>
        <el-progress v-if="uploading" :percentage="filePercentage" :width="200" style="margin:16px 0;" />
        <el-table v-loading="loading" :data="fileInfo" border style="width: 100%;margin-top: 16px;">
          <el-table-column prop="fileName" label="文件名称">
            <template v-slot="{ row }">
              <el-button type="text" @click="handlePreview(row)">{{ row.fileName }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="createBy" label="上传人" />
          <el-table-column prop="createTime" label="上传时间" />
          <el-table-column prop="unit" label="操作" width="160">
            <template v-slot="{ row, $index }">
              <el-popconfirm
                v-if="!disStatus"
                confirm-button-text="确定"
                cancel-button-text="取消"
                icon=""
                title="确认删除该文件吗？"
                @confirm="removeAttachment($index)"
              >
                <el-button v-if="!disStatus" slot="reference" type="text" style="color:#FF0000;">删除</el-button>
              </el-popconfirm>
              <el-button v-if="disStatus" type="text" @click="Upload(row)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="!disStatus" class="remarks">
        <h3>商务发货备注说明</h3>
        <el-input
          v-model="partialInvoiceDetail.deliverRemarkBusiness"
          type="textarea"
          :rows="4"
          placeholder="请输入内容"
          maxlength="500"
          show-word-limit
          resize="none"
        />
      </div>
      <div v-if="disStatus" class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              商务发货备注说明 :
            </div>
            <div class="rj-baseinfo__item">
              {{ partialInvoiceDetail.deliverRemarkBusiness }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="!disStatus" class="email" style="margin-top: 12px;">
        <el-select
          v-model="partialInvoiceDetail.noticeEmail"
          placeholder="请选择发送的邮箱"
          style="width: 300px;"
          clearable
          @change="handleNoticeEmailChange"
        >
          <el-option
            v-for="item in noticeEmailOptions"
            :key="item.dictValue"
            :label="item.dictLabel"
            :value="item.dictValue"
          />
        </el-select>
        <el-checkbox
          v-model="info.notifyApprover"
          style="margin-left: 20px;"
          @change="handleNotifyApproverChange"
        >
          是否通知审批人
        </el-checkbox>
      </div>
      <div v-if="disStatus" class="email">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              已通知审批人 :
            </div>
            <div class="rj-baseinfo__item">
              {{ partialInvoiceDetail.noticeEmail }}
            </div>
          </div>
        </div>
      </div>
      <div class="footer" style="text-align: center; margin-top: 20px;">
        <el-button
          v-if="!disStatus"
          type="primary"
          :loading="submitLoading"
          :disabled="submitLoading"
          @click="handleSubmit"
        >
          提交申请
        </el-button>
        <el-button
          v-if="!disStatus"
          :loading="rejectLoading"
          :disabled="rejectLoading"
          @click="reject"
        >
          驳回
        </el-button>
      </div>
    </div>
    <SubmitDialog ref="SubmitVisible" @SubmitApprove="SubmitApprove" />
    <RejectDialog ref="ReasonDialogVisible" @HandleReject="HandleReject" />
  </div>
</template>
<script>
import RejectDialog from '../components/RejectDialog.vue';
import SubmitDialog from '../components/SubmitDialog.vue';
import { GetBatchDetails, ExportShipment, ConfirmBussiness, RejectSupply, GetAllocationInfo, GetProductDetails } from '@/API/BatchManagement.js';
import { getDictData as getInternationalDictData } from '@/API/international';
import { getDictData as getCommonDictData, attachmentGetToken, getUrlByFileID, getLoginUser } from '@/API';
import { downloadBlobFile, downloadUrlFile, formatDate } from '@/libs/util';
import changTitle from '@/libs/changTitle';
import AxiosApi from '@/API/fileAxios';
import { mapState } from 'vuex';
export default {
  components: {
    SubmitDialog,
    RejectDialog
  },
  data () {
    return {
      loading: false,
      currentEamil: '', // 当前输入的邮箱
      isEmailValid: true, // 邮箱格式是否有效
      emailStatu: true, // 控制邮箱输入框显示隐藏
      disStatus: this.$route.query.status,
      id: this.$route.query.id,
      isDelete: this.$route.query.isDelete,
      SubmitVisible: false,
      ReasonDialogVisible: false,
      intelPartialInvoiceInfo: {},
      partialInvoiceDetail: {
        receiptAddressId: '',
        mergeShip: 1,
        authorizationEmail: '',
        batchNum: '',
        deliverRemarkBusiness: '',
        noticeEmail: ''
      },
      productList: [],
      physicalProductList: [],
      nonPhysicalProductList: [],
      fileInfo: [],
      allocatedDetail: [],
      info: {
        isHeader: 2,
        isOtherDelivery: 2,
        receiptAddressId: '',
        notifyApprover: false,
        fileInfo: []
      },
      AddressList: [],
      noticeEmailOptions: [],
      currentEmailArr: [],
      batchOptions: Array.from({ length: 99 }, (_, index) => {
        const value = String(index + 1);
        return { label: value, value };
      }),
      uploadUrl: '',
      downloadUrl: '',
      token: '',
      uploading: false,
      filePercentage: 0,
      staffEmail: '',
      submitLoading: false,
      rejectLoading: false,
      productPagination: {
        physical: {
          currentPage: 1,
          pageSize: 100
        },
        nonPhysical: {
          currentPage: 1,
          pageSize: 100
        }
      }
    };
  },
  computed: {
    ...mapState(['user']),
    currentEmailList () {
      return this.currentEmailArr.filter(item => item);
    },
    readonlyAuthorizationEmails () {
      const source = this.partialInvoiceDetail.authorizationEmail || '';
      return source ? source.split(',').map(item => item.trim()).filter(Boolean) : [];
    },
    selectedReceiptAddressLabel () {
      const id = this.partialInvoiceDetail.receiptAddressId;
      if (id === undefined || id === null || id === '') {
        return '';
      }
      const matched = this.AddressList.find(item => String(item.dictValue) === String(id));
      return matched && matched.dictLabel ? matched.dictLabel : '';
    },
    physicalProductPageData () {
      return this.paginateList(this.physicalProductList, this.productPagination.physical);
    },
    nonPhysicalProductPageData () {
      return this.paginateList(this.nonPhysicalProductList, this.productPagination.nonPhysical);
    }
  },
  watch: {
    'partialInvoiceDetail.receiptAddressId' (value) {
      this.info.receiptAddressId = value ? String(value) : '';
    },
    disStatus () {
      this.updatePageTitle();
    },
    physicalProductList () {
      this.ensurePaginationBounds('physical');
    },
    nonPhysicalProductList () {
      this.ensurePaginationBounds('nonPhysical');
    }
  },
  methods: {
    // 日期字段格式化为 yyyy-MM-dd
    formatDateOnly (value) {
      if (value === undefined || value === null) {
        return '-';
      }
      if (typeof value === 'string') {
        const trimmed = value.trim();
        if (!trimmed) {
          return '-';
        }
        if (trimmed.includes(' ')) {
          return trimmed.split(' ')[0];
        }
        if (trimmed.includes('T')) {
          return trimmed.split('T')[0];
        }
      }
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return value || '-';
      }
      return formatDate(date, 'yyyy-MM-dd');
    },
    formatPercentage (value) {
      const num = Number(value);
      if (Number.isFinite(num)) {
        return `${(num * 100).toFixed(2)}%`;
      }
      return value || '';
    },
    paginateList (list, pagination = {}) {
      const source = Array.isArray(list) ? list : [];
      const pageSize = Number(pagination.pageSize) || 100;
      const currentPage = Number(pagination.currentPage) || 1;
      const start = (currentPage - 1) * pageSize;
      return source.slice(start, start + pageSize);
    },
    resetProductPagination () {
      this.productPagination.physical.currentPage = 1;
      this.productPagination.nonPhysical.currentPage = 1;
    },
    ensurePaginationBounds (type) {
      const pagination = this.productPagination[type];
      if (!pagination) {
        return;
      }
      const list = type === 'physical' ? this.physicalProductList : this.nonPhysicalProductList;
      const pageSize = Number(pagination.pageSize) || 100;
      const maxPage = Math.max(1, Math.ceil((Array.isArray(list) ? list.length : 0) / pageSize) || 1);
      if (pagination.currentPage > maxPage) {
        pagination.currentPage = maxPage;
      }
      if (pagination.currentPage < 1) {
        pagination.currentPage = 1;
      }
    },
    handlePhysicalPageChange (page) {
      this.productPagination.physical.currentPage = page;
    },
    handleNonPhysicalPageChange (page) {
      this.productPagination.nonPhysical.currentPage = page;
    },
    handlePhysicalSizeChange (size) {
      this.productPagination.physical.pageSize = size;
      this.productPagination.physical.currentPage = 1;
      this.ensurePaginationBounds('physical');
    },
    handleNonPhysicalSizeChange (size) {
      this.productPagination.nonPhysical.pageSize = size;
      this.productPagination.nonPhysical.currentPage = 1;
      this.ensurePaginationBounds('nonPhysical');
    },
    updatePageTitle () {
      const title = this.disStatus ? '已确认批次发货申请' : '待确认批次发货申请';
      changTitle(title, process.env.BASE_URL);
    },
    // 点击“添加邮箱”时展示输入框，并默认填入当前账号邮箱方便确认
    handleAddEmailClick () {
      if (!this.emailStatu) {
        this.focusEmailInput();
        return;
      }
      this.emailStatu = false;
      this.currentEamil = '';
      this.isEmailValid = true;
      this.$nextTick(() => {
        this.focusEmailInput();
      });
    },
    // 兼容 el-input 组件和原生 input 的聚焦方式，保证光标定位
    focusEmailInput () {
      const input = this.$refs.emailInput;
      if (input && typeof input.focus === 'function') {
        input.focus();
        return;
      }
      if (input && input.$refs && input.$refs.input && typeof input.$refs.input.focus === 'function') {
        input.$refs.input.focus();
      }
    },
    handleEmailClose (email) {
      this.currentEmailArr = this.currentEmailArr.filter(item => item !== email);
      this.syncAuthorizationEmail();
    },
    // 将标签列表同步回授权邮箱字段，保持接口提交一致
    syncAuthorizationEmail () {
      this.transformationEmailValue();
    },
    transformationEmailValue () {
      const cleaned = Array.from(new Set(this.currentEmailArr.map(item => item.trim()).filter(Boolean)));
      this.currentEmailArr = cleaned;
      this.partialInvoiceDetail.authorizationEmail = cleaned.join(',');
    },
    initializeEmailFields () {
      const raw = this.partialInvoiceDetail.authorizationEmail || '';
      this.currentEmailArr = raw ? raw.split(',').map(item => item.trim()).filter(Boolean) : [];
      this.syncAuthorizationEmail();
      this.ensureStaffEmailPreset();
    },
    // 登录用户的邮箱默认出现在授权列表中，避免漏填
    ensureStaffEmailPreset () {
      const email = (this.staffEmail || '').trim();
      if (!email || !this.isValidEmailFormat(email)) {
        return;
      }
      if (!this.currentEmailArr.includes(email)) {
        this.currentEmailArr.push(email);
        this.transformationEmailValue();
      }
    },
    syncAttachmentInfo () {
      this.fileInfo = this.fileInfo.map(item => this.normalizeAttachment(item));
      this.info.fileInfo = this.fileInfo.map(item => ({ ...item }));
    },
    // 区分有实物产品和无实物产品
    splitProductList () {
      const list = Array.isArray(this.productList) ? this.productList : [];
      const isPhysical = (item) => this.resolvePhysicalFlag(item && item.physicalFlag);
      this.physicalProductList = list.filter(item => isPhysical(item));
      this.nonPhysicalProductList = list.filter(item => !isPhysical(item));
      this.resetProductPagination();
      this.ensurePaginationBounds('physical');
      this.ensurePaginationBounds('nonPhysical');
    },
    resolvePhysicalFlag (flag) {
      if (flag === true || flag === 1) {
        return true;
      }
      if (flag === false || flag === 0) {
        return false;
      }
      if (typeof flag === 'string') {
        const value = flag.trim().toLowerCase();
        if (['1', 'true', 'y', 'yes'].includes(value)) {
          return true;
        }
        if (['0', 'false', 'n', 'no'].includes(value)) {
          return false;
        }
      }
      return Boolean(flag);
    },
    normalizeAttachment (item = {}) {
      const token = this.resolveFileToken(item);
      const directUrl = this.resolveDirectUrl(item);
      const nameCandidates = [
        item.fileName,
        item.enclosureName,
        item.originalFileName,
        item.originName,
        item.name
      ];
      const fileName = nameCandidates.find(val => typeof val === 'string' && val.trim());
      return {
        ...item,
        fileName: fileName ? fileName.trim() : (token || '附件'),
        fileToken: token || item.fileToken,
        fileServeDownUrl: directUrl || item.fileServeDownUrl || ''
      };
    },
    resolveFileToken (row) {
      if (!row || typeof row !== 'object') {
        return '';
      }
      const candidates = [
        row.fileToken,
        row.fileId,
        row.fileID,
        row.fileCode,
        row.FileID,
        row.file_id,
        row.rFileCode,
        row.attachmentFileId,
        row.attachmentId,
        row.fid,
        row.FID
      ];
      const token = candidates.find(item => typeof item === 'string' && item.trim()) || candidates.find(item => typeof item === 'number');
      return token ? String(token).trim() : '';
    },
    resolveDirectUrl (row) {
      if (!row || typeof row !== 'object') {
        return '';
      }
      const directCandidates = [
        row.fileServeDownUrl,
        row.fileUrl,
        row.url,
        row.filePath,
        row.path
      ];
      const url = directCandidates.find(item => typeof item === 'string' && item.trim());
      return url ? url.trim() : '';
    },
    async ensureUploadParams () {
      if (this.uploadUrl && this.token && this.downloadUrl) {
        return true;
      }
      await this.initUploadParams();
      return Boolean(this.uploadUrl && this.token && this.downloadUrl);
    },
    initUploadParams () {
      return attachmentGetToken().then(res => {
        const json = res.data || {};
        if (Number(json.status) === 200 && json.data) {
          this.uploadUrl = json.data.uploadUrl || '';
          this.token = json.data.token || '';
          this.downloadUrl = json.data.downloadUrl || '';
        } else {
          return Promise.reject(new Error('获取上传参数失败'));
        }
      }).catch(err => {
        this.$message && this.$message.error('获取文件上传参数失败，请稍后重试');
        throw err;
      });
    },
    handleAttachmentUpload (upload) {
      const { file, onSuccess, onError } = upload;
      if (!file) {
        return;
      }
      const fileName = file.name || '';
      const extension = fileName.slice(fileName.lastIndexOf('.')).toLowerCase();
      const allowList = ['.pdf', '.doc', '.docx', '.jpg', '.png', '.gif', '.zip', '.rar', '.xlsx', '.xls'];
      if (!allowList.includes(extension)) {
        this.$message && this.$message.error('文件只允许 pdf、word、图片、压缩包上传');
        onError && onError(new Error('invalid file type'));
        return;
      }
      if (file.size > 31457280) {
        this.$message && this.$message.error('上传文件大小不能大于30M');
        onError && onError(new Error('file too large'));
        return;
      }
      this.ensureUploadParams().then(() => {
        const form = new FormData();
        form.append('files', file);
        this.uploading = true;
        return AxiosApi.post(`${this.uploadUrl}?Token=${this.token}`, form, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              this.filePercentage = Math.floor(progressEvent.loaded / progressEvent.total * 100);
            }
          }
        }).then(res => {
          const json = res.data || {};
          if (json.status === '200' && Array.isArray(json.data) && json.data[0]) {
            const payload = json.data[0];
            const fileInfo = this.normalizeAttachment({
              fileName: payload.FullName || fileName,
              fileToken: payload.FID,
              createTime: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
              createBy: this.user?.userName || ''
            });
            this.fileInfo.push(fileInfo);
            this.syncAttachmentInfo();
            this.$message && this.$message.success(`文件“${fileName}”上传成功`);
            onSuccess && onSuccess(res, file);
          } else {
            this.$message && this.$message.error(`文件“${fileName}”上传失败`);
            onError && onError(new Error('upload failed'));
          }
        });
      }).catch(() => {
        this.$message && this.$message.error(`文件“${fileName}”上传失败`);
        onError && onError(new Error('upload failed'));
      }).finally(() => {
        this.uploading = false;
        this.filePercentage = 0;
      });
    },
    removeAttachment (index) {
      if (index < 0 || index >= this.fileInfo.length) {
        return;
      }
      this.fileInfo.splice(index, 1);
      this.syncAttachmentInfo();
    },
    async Upload (row) {
      const directUrl = this.resolveDirectUrl(row);
      const token = this.resolveFileToken(row);
      if (!directUrl && !token) {
        this.$message && this.$message.warning('文件缺少下载信息');
        return;
      }
      try {
        if (directUrl) {
          downloadUrlFile(directUrl, row.fileName || '附件');
          return;
        }
        await this.ensureUploadParams();
        const url = `${this.downloadUrl}/${token}?Token=${this.token}`;
        downloadUrlFile(url, row.fileName || '附件');
      } catch (error) {
        this.$message && this.$message.error('文件下载失败，请稍后重试');
      }
    },
    handlePreview (row) {
      const directUrl = this.resolveDirectUrl(row);
      const token = this.resolveFileToken(row);
      if (!directUrl && !token) {
        this.$message && this.$message.warning('文件缺少预览信息');
        return;
      }
      if (directUrl) {
        window.open(directUrl, '_blank');
        return;
      }
      getUrlByFileID(token).then(res => {
        const json = res.data || {};
        if (json.status === '200' && json.data) {
          window.open(json.data, '_blank');
        }
      });
    },
    handleNoticeEmailChange (value) {
      this.info.noticeEmail = value;
      this.info.notifyApprover = Boolean(value);
    },
    handleNotifyApproverChange (checked) {
      if (checked && !this.info.noticeEmail) {
        this.info.notifyApprover = false;
        if (this.$message) {
          this.$message.warning('请先选择发送的邮箱');
        }
      }
    },
    getNoticeEmailOptions () {
      const params = ['CUSTOMS_NOTICE'];
      getCommonDictData(params).then(res => {
        const { status, data } = res.data || {};
        if (status === '200' && Array.isArray(data)) {
          const dict = data.find(item => item.dictType === 'CUSTOMS_NOTICE');
          this.noticeEmailOptions = Array.isArray(dict?.dictDataVOS) ? dict.dictDataVOS : [];
        } else if (status === '200' && Array.isArray(data?.dictDataVOS)) {
          this.noticeEmailOptions = data.dictDataVOS;
        }
      }).catch(() => {
        this.noticeEmailOptions = [];
      });
    },
    buildProductSummary ({ columns }, sourceList = []) {
      const list = Array.isArray(sourceList) ? sourceList : [];
      const getTotal = (prop) => list.reduce((acc, item) => acc + (Number(item[prop]) || 0), 0);
      return columns.map((column, index) => {
        if (index === 0) {
          return '总计';
        }
        if (column.property === 'productNum') {
          return getTotal('productNum').toFixed(2);
        }
        if (column.property === 'amountSum') {
          return getTotal('amountSum').toFixed(2);
        }
        return '';
      });
    },
    renderPhysicalSummary (params) {
      return this.buildProductSummary(params, this.physicalProductList);
    },
    renderNonPhysicalSummary (params) {
      return this.buildProductSummary(params, this.nonPhysicalProductList);
    },
    handleSubmit () {
      if (this.submitLoading) {
        return;
      }
      this.syncAuthorizationEmail();
      this.syncAttachmentInfo();
      this.info.receiptAddressId = this.partialInvoiceDetail.receiptAddressId ? String(this.partialInvoiceDetail.receiptAddressId) : '';
      const missingAddress = !this.partialInvoiceDetail.receiptAddressId;
      let hasEmails = Boolean(this.partialInvoiceDetail.authorizationEmail && this.partialInvoiceDetail.authorizationEmail.trim());
      if (missingAddress) {
        this.$message && this.$message.warning('请选择收货地址');
        return;
      }
      if (!hasEmails) {
        // 若用户未手动添加邮箱，尝试使用当前登录邮箱兜底
        const fallbackEmail = (this.staffEmail || '').trim();
        if (fallbackEmail && this.isValidEmailFormat(fallbackEmail) && !this.currentEmailArr.includes(fallbackEmail)) {
          this.currentEmailArr.push(fallbackEmail);
          this.transformationEmailValue();
          hasEmails = true;
        }
        if (!hasEmails) {
          this.$message && this.$message.warning('请至少添加一个授权邮箱');
          this.handleAddEmailClick();
          return;
        }
      }
      this.$refs.SubmitVisible.openDialog();
    },
    reject () {
      if (this.rejectLoading) {
        return;
      }
      this.$refs.ReasonDialogVisible.openDialog();
    },
    HandleReject ({ reason, done } = {}) {
      if (this.rejectLoading) {
        if (typeof done === 'function') {
          done(false);
        }
        return;
      }
      const approvalComments = typeof reason === 'string' ? reason : '';
      const params = {
        approveType: 0, // 审批类型 -1 废弃 0 驳回 1 召回 2 同意
        approvalComments,
        remarks: this.partialInvoiceDetail.deliverRemarkBusiness, // 发货备注
        id: this.id, // 主发货单表Id
        type: 1
      };
      this.rejectLoading = true;
      const finish = (success = false) => {
        this.rejectLoading = false;
        if (typeof done === 'function') {
          done(success);
        }
      };
      RejectSupply(params).then(res => {
        if (res.data.status === '200') {
          this.$message.success(res.data.err);
          finish(true);
          this.$router.go(-1);
        } else {
          this.$message.error(res.data.err);
          finish(false);
        }
      }).catch(() => {
        this.$message && this.$message.error('驳回失败，请稍后重试');
        finish(false);
      });
    },
    getInfo () {
      this.loading = true;
      const { query = {}, params = {} } = this.$route || {};
      const batchApplyId = query.batchApplyId || params.batchApplyId || params.contractNum || '';
      GetBatchDetails({ deliveryNum: batchApplyId, id: this.id }).then(res => {
        this.loading = false;
        this.intelPartialInvoiceInfo = res.data.data.intelPartialInvoiceInfo || {};
        this.partialInvoiceDetail = res.data.data.partialInvoiceDetail || {};
        this.partialInvoiceDetail.receiptAddressId = this.partialInvoiceDetail.receiptAddressId ? String(this.partialInvoiceDetail.receiptAddressId) : '';
        this.partialInvoiceDetail.authorizationEmail = this.partialInvoiceDetail.authorizationEmail || '';
        this.productList = res.data.data.productList || [];
        this.splitProductList();
        const attachments = Array.isArray(res.data.data.fileInfo) ? res.data.data.fileInfo : [];
        this.fileInfo = attachments.map(item => this.normalizeAttachment(item));
        this.syncAttachmentInfo();
        const noticeEmail = this.partialInvoiceDetail.noticeEmail || '';
        Object.assign(this.info, {
          batchNum: this.partialInvoiceDetail.batchNum ? String(this.partialInvoiceDetail.batchNum) : '',
          receiptAddressId: this.partialInvoiceDetail.receiptAddressId ? String(this.partialInvoiceDetail.receiptAddressId) : '',
          noticeEmail,
          notifyApprover: Boolean(noticeEmail)
        });
        this.initializeEmailFields();
      }).catch(() => {
        this.loading = false;
      });
    },
    exportProduct () {
      const params = {
        omsBatchNum: this.intelPartialInvoiceInfo.omsBatchNum
      };
      ExportShipment(params).then((res) => {
        downloadBlobFile({
          content: res.data,
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          fileName: '发货明细单'
        });
      });
    },
    getClerkAllocated () {
      if (this.isDelete !== '1') {
        GetAllocationInfo(this.id).then(res => {
          this.allocatedDetail = res.data.data || [];
        });
      } else {
        return '';
      }
    },
    getDict () {
      const params = { dictType: 'intel_partial_addr_id' };
      getInternationalDictData(params).then(res => {
        let { status, data } = res.data;
        if (status === '200') {
          const normalizeOptions = () => {
            if (Array.isArray(data)) {
              // 兼容单个/多个字典类型的不同返回格式
              const dict = data.find(item => Array.isArray(item?.dictDataVOS));
              if (dict) {
                return dict.dictDataVOS;
              }
              return data;
            }
            if (Array.isArray(data?.dictDataVOS)) {
              return data.dictDataVOS;
            }
            return [];
          };
          this.AddressList = normalizeOptions();
        }
      });
    },
    GetProduct () {
      const params = {
        id: this.id,
        pageIndex: 1,
        pageSize: 9999
      };
      GetProductDetails(params).then(res => {
        const { status, data } = res.data || {};
        const list = Array.isArray(data?.list) ? data.list : Array.isArray(data) ? data : [];
        if (status === '200') {
          this.productList = list;
        } else {
          this.productList = [];
        }
        this.splitProductList();
      }).catch(() => {
        this.productList = [];
        this.splitProductList();
      });
    },
    SubmitApprove ({ done } = {}) {
      if (this.submitLoading) {
        if (typeof done === 'function') {
          done(false);
        }
        return;
      }
      const params = {
        intelPartialInvoiceInfo: this.intelPartialInvoiceInfo,
        partialInvoiceProducts: this.productList,
        partialInvoiceDetail: this.partialInvoiceDetail,
        fileInfo: this.fileInfo
      };
      this.submitLoading = true;
      const finish = (success = false) => {
        this.submitLoading = false;
        if (typeof done === 'function') {
          done(success);
        }
      };
      ConfirmBussiness(params).then((res) => {
        if (res.data.status === '200') {
          this.$message.success(res.data.err);
          finish(true);
          this.$router.go(-1);
        } else {
          this.$message.error(res.data.err);
          finish(false);
        }
      }).catch(() => {
        this.$message && this.$message.error('提交失败，请稍后重试');
        finish(false);
      });
    },
    getUser () {
      getLoginUser().then(res => {
        const { status, data } = res.data || {};
        if (status === '200' && data) {
          this.staffEmail = data.staffEmail || '';
          // 登录信息返回后再次尝试写入默认邮箱，防止初始化时机错过
          this.ensureStaffEmailPreset();
        }
      });
    },
    // 即时校验输入邮箱格式，提示用户纠正
    validateEmail () {
      const value = (this.currentEamil || '').trim();
      if (!value) {
        this.isEmailValid = true;
        return;
      }
      this.isEmailValid = this.isValidEmailFormat(value);
    },
    isValidEmailFormat (value) {
      const emailPattern = /^([a-zA-Z0-9]+[._-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[._-]?)*[a-zA-Z0-9]+(\.[a-zA-Z]{2,})+$/i;
      return emailPattern.test(value);
    },
    // 失焦或回车时将输入转为标签，并给出重复/格式错误提示
    emailBlur () {
      const value = (this.currentEamil || '').trim();
      if (value) {
        if (!this.isValidEmailFormat(value)) {
          this.isEmailValid = false;
          this.$message && this.$message.warning('请输入有效的邮箱地址');
          this.focusEmailInput();
          return;
        }
        if (this.currentEmailArr.includes(value)) {
          this.$message && this.$message.info('该邮箱已存在');
        } else {
          this.currentEmailArr.push(value);
          this.transformationEmailValue();
        }
      }
      this.currentEamil = '';
      this.isEmailValid = true;
      this.emailStatu = true;
    }
  },
  mounted () {
    this.getInfo();
    this.getClerkAllocated();
    this.getDict();
    this.getNoticeEmailOptions();
    this.ensureUploadParams().catch(() => {});
    this.getUser();
    this.GetProduct();
    this.updatePageTitle();
  }
};
</script>
<style scoped>
.email-editor {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.email-input-wrapper {
  max-width: 320px;
}
.email-input {
  width: 320px;
}
.email-error {
  margin-top: 4px;
  color: #f56c6c;
  font-size: 12px;
}
.email-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.itemTag {
  margin-right: 8px;
  margin-bottom: 4px;
}
.required-marker {
  color: #f56c6c;
  margin-right: 4px;
}
.tableList {
  width: 100%;
  margin-top: 16px;
}
</style>
